if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: ['.product__media-item'],
        };

        this.sliderInstance = false;
        this.thumbsInstance = false;
        this.metaobjectData = null; 
      }

      connectedCallback() {
        FoxTheme.Motion.inView(this, this.init.bind(this));
      }

      init() {
        this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.sectionId = this.id.replace('MediaGallery-', '');
        this.mediaLayout = this.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === 'true';
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
        this.enableImageZoom = this.dataset.enableImageZoom === 'true';
        this.context = this.dataset.context;
        this.setSliderOptions();

        const jsonScript = document.getElementById(`ProductGallery-Metaobjects-${this.sectionId}`);
        if (jsonScript) {
          try {
            this.metaobjectData = JSON.parse(jsonScript.textContent);
          } catch(e) { 
            console.error("BRU: JSON Parse Error", e); 
          }
        }

        // Subscribe to selection change
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, (pubsubData) => {
          const section = pubsubData.data.event.target.closest('.section');
          if (section && section.id.includes(this.sectionId)) {
            this.handleVariantChange();
          }
        });

        // Run on initial load
        this.handleVariantChange();

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();

        if (this.enableImageZoom) {
          this.initImageZoom();
        }
      }

      handleize(str) {
        return str.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
      }

handleVariantChange() {
        if (!this.metaobjectData) return;

        const sectionContainer = this.closest('.section') || document.getElementById(`shopify-section-${this.sectionId}`);
        const selectsContainer = sectionContainer.querySelector('variant-selects');
        if (!selectsContainer) return;

        const inputs = Array.from(selectsContainer.querySelectorAll('.product-form__input'));
        const options = inputs.map(input => {
          const selected = input.querySelector('input:checked, select');
          const val = selected ? (selected.value || selected.dataset.value || "") : "";
          return this.handleize(val);
        }).filter(val => val !== "");

        const mattressKey = options.slice(0, 2).join('_');
        
        const baseKey = options.join('_');

        let matchedData = null;

        if (this.metaobjectData.mattress && this.metaobjectData.mattress[mattressKey]) {
          matchedData = this.metaobjectData.mattress[mattressKey];
        } else if (this.metaobjectData.drawer_base && this.metaobjectData.drawer_base[baseKey]) {
          matchedData = this.metaobjectData.drawer_base[baseKey];
        } else if (this.metaobjectData.bed_base && this.metaobjectData.bed_base[baseKey]) {
          matchedData = this.metaobjectData.bed_base[baseKey];
        } else if (this.metaobjectData.pillows && this.metaobjectData.pillows[baseKey]) {
          matchedData = this.metaobjectData.pillows[baseKey];
        }

        if (matchedData && matchedData.images.length > 0) {
          this.rebuildGallery(matchedData.images, matchedData.lifestyle || []);
        }
      }

      rebuildGallery(images, lifestyle) {
        this.destroySlider();
        if (this.thumbsInstance && this.thumbsInstance.slider) {
          this.thumbsInstance.slider.destroy(true, true);
          this.thumbsInstance = false;
        }

        const allImages = [...images, ...lifestyle];
        let viewerHTML = '';
        let thumbsHTML = '';

        allImages.forEach((imgUrl, index) => {
          viewerHTML += `
            <div class="product__media-item swiper-slide" data-media-type="image" data-media-index="${index}" data-src="${imgUrl}" data-pswp-width="1200" data-pswp-height="1200">
              <div class="product__media media-wrapper relative" style="padding-top: 100%;">
                <img src="${imgUrl}" class="image-lazy absolute top-0 left-0 w-full h-full object-cover" loading="${index === 0 ? 'eager' : 'lazy'}" alt="Product Image">
              </div>
            </div>`;

          if (this.elements.thumbnails) {
            thumbsHTML += `
              <div class="product__thumbs-item swiper-slide" data-media-position="${index + 1}">
                <div class="product__thumbs-container relative blocks-radius-md media-wrapper cursor-pointer">
                  <div class="product__thumbs-inner" style="--aspect-ratio: 1">
                    <img src="${imgUrl}&width=200" class="image-lazy absolute top-0 left-0 w-full h-full object-cover" loading="lazy">
                  </div>
                </div>
              </div>`;
          }
        });

        const viewerWrapper = this.elements.viewer.querySelector('.swiper-wrapper');
        if (viewerWrapper) viewerWrapper.innerHTML = viewerHTML;

        if (this.elements.thumbnails) {
          const thumbsWrapper = this.elements.thumbnails.querySelector('.swiper-wrapper');
          if (thumbsWrapper) thumbsWrapper.innerHTML = thumbsHTML;
        }

        this.elements.mediaItems = Array.from(this.querySelectorAll('.product__media-item'));
        this.initSlider();
        
        if (this.enableImageZoom) {
          this.initImageZoom();
        }
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap) || 8;
        const mediaItemGapMobile = parseInt(this.dataset.mediaItemGapMobile) || 12;

        this.sliderOptions = {
          init: false,
          slidesPerView: this.enableMobileThumbnails ? 1 : 'auto',
          spaceBetween: mediaItemGapMobile,
          loop: false,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,
          breakpoints: { 768: { spaceBetween: mediaItemGap } },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
          threshold: 2,
        };

        this.thumbsOptions = {
          slidesPerView: 4,
          spaceBetween: mediaItemGapMobile,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
          breakpoints: {
            461: { slidesPerView: 5 },
            768: { spaceBetween: mediaItemGap },
          },
        };

        if (this.mediaLayout === 'vertical-carousel') {
          this.thumbsOptions.breakpoints[768] = {
            direction: 'vertical',
            slidesPerView: 'auto',
            spaceBetween: mediaItemGap,
          };
        }
      }

      updateMediaLayout() {
        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance !== 'object') {
          if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
            this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions);
            this.thumbsInstance.init();

            this.sliderOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
              autoScrollOffset: 2,
            };
          }

          this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, [
            FoxTheme.Swiper.Thumbs,
          ]);
          this.sliderInstance.init();
          this.handleSliderAfterInit();
          this.handleSlideChange();
          this.sliderInstance.slider.init();
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy(true, true);
          this.sliderInstance = false;
        }
      }

      initImageZoom() {
        let dataSource = [];
        const allMedia = Array.from(this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)'));
        
        allMedia.forEach((media) => {
          if (media.dataset.mediaType === 'image') {
            dataSource.push({
              id: media.dataset.mediaIndex,
              src: media.dataset.src,
              width: parseInt(media.dataset.pswpWidth) || 1200,
              height: parseInt(media.dataset.pswpHeight) || 1200,
              mediaType: 'image',
            });
          }
        });

        if (this.lightbox) this.lightbox.destroy();

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          zoom: false,
          close: true,
          counter: true,
          arrowPrev: true,
          arrowNext: true
        });

        this.lightbox.init();

        const zoomTriggers = this.querySelectorAll('.product__media');
        zoomTriggers.forEach(trigger => {
           trigger.onclick = (e) => {
              const slide = e.target.closest('.product__media-item');
              if (slide) {
                this.lightbox.loadAndOpen(parseInt(slide.dataset.mediaIndex) || 0);
              }
           };
        });
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on('afterInit', (swiper) => {
          const { slides, activeIndex } = swiper;
          if (slides[activeIndex]) {
            this.toggleSliderDraggableState(slides[activeIndex].dataset.mediaType !== 'model');
          }
        });
      }

      handleSlideChange() {
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { activeIndex, thumbs } = swiper;
          if (thumbs.swiper) thumbs.swiper.slideTo(activeIndex);
        });
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }
    }
  );
}